import React, { useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import { dataverseService } from '../services/dataverseService';
import { getDataverseErrorMessage } from '../lib/dataverseErrorHandler';

const AddToAccessGroupDialog = ({
  open,
  onClose,
  title,
  onAdded,
  addToGroup
}) => {
  const [groups, setGroups] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) {
      return;
    }

    let active = true;
    setLoading(true);
    setError(null);
    setSelectedGroupId('');

    dataverseService.accessGroupService
      .getAll()
      .then((data) => {
        if (active) {
          setGroups(data);
        }
      })
      .catch((loadError) => {
        if (active) {
          setError(getDataverseErrorMessage(loadError));
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [open]);

  const handleAdd = async () => {
    if (!selectedGroupId) {
      return;
    }

    setSaving(true);
    setError(null);

    try {
      await addToGroup(selectedGroupId);
      onAdded?.();
      onClose();
    } catch (saveError) {
      setError(getDataverseErrorMessage(saveError));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel id="access-group-select-label">Tilgangsgruppe</InputLabel>
            <Select
              labelId="access-group-select-label"
              label="Tilgangsgruppe"
              value={selectedGroupId}
              onChange={(event) => setSelectedGroupId(event.target.value)}
            >
              {groups.map((group) => (
                <MenuItem key={group.id} value={group.id}>
                  {group.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {error && (
          <Button color="error" size="small" sx={{ mt: 2, textTransform: 'none' }} disabled>
            {error}
          </Button>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Avbryt
        </Button>
        <Button variant="contained" onClick={handleAdd} disabled={saving || !selectedGroupId}>
          {saving ? 'Legger til…' : 'Legg til'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddToAccessGroupDialog;
